import { ROLES } from './shared/constants';

const { SYS_ADMIN, ADMIN, BRAND_MANAGER, BRAND_TECH_OPERATOR, BRAND_SUPPORT_OPERATOR } = ROLES;

/**
 * Required environment variables for One Dashboard.
 * These variables must be defined in `.env.example` to be properly injected in `index.html`
 */
export const APP_CONFIG = {
  appId: import.meta.env.APP_ID as string,
  appVersion: import.meta.env.APP_VERSION as string,
  apiBaseUrl: import.meta.env.API_BASE_URL as string,
  dashboardAllowedAccessRoles: [SYS_ADMIN, ADMIN, BRAND_MANAGER, BRAND_TECH_OPERATOR, BRAND_SUPPORT_OPERATOR],
  datadogRumSessionSampleRate: import.meta.env.DATADOG_RUM_SESSION_SAMPLE_RATE as string,
  datadogRumSessionReplaySampleRate: import.meta.env.DATADOG_RUM_SESSION_REPLAY_SAMPLE_RATE as string,
  debugForm: import.meta.env.DEBUG_FORM as string,
  defaultShoppingEmail: 'pelican@culligan.com',
  environment: import.meta.env.ENVIRONMENT as string,
  gmapsApiKey: import.meta.env.GMAPS_API_KEY as string,
  tenantOverride: import.meta.env.TENANT_OVERRIDE as string,
  ffTroubleshootingChat: import.meta.env.FF_TROUBLESHOOTING_CHAT as string,
  ffEnableSupportRoles: import.meta.env.FF_ENABLE_SUPPORT_ROLES as string,
} as const;

export default APP_CONFIG;
